import { BUTTON_ICON_MINIMIZE_CLASSNAME_MODIFIERS } from './ButtonIconMinimize.constants'

export function getButtonIconMinimizePositionClassName(iconPosition, height) {
  return BUTTON_ICON_MINIMIZE_CLASSNAME_MODIFIERS[iconPosition][height]
}
